/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */

import React from 'react';
import {dlsColor} from '../theme/theme';
import {IconProps} from '../types/types';
import ThemeIconProvider from './ThemeIconProvider';
import useIconDLS from './useIconDLS';

interface BatteryIconProps extends IconProps {
  batteryPercentage?: number | string;
  id: string;
}

/*
 * Defines the Design Language System (DLS) Battery Icon component.
 * Includes definition to partially fill the battery body based on the percentage
 */
export const BatteryIcon = ({
  batteryPercentage = 100,
  size = 16,
  color = dlsColor('grey3'),
  id
}: BatteryIconProps) => {
  const {iconSize, iconColor} = useIconDLS({size, color});
  return (
    <ThemeIconProvider name='BatteryIcon' size={size} color={color} legacyIcon={(
      <svg width={iconSize} height={iconSize} viewBox='0 0 16 10' fill='none'>
        <defs>
          <linearGradient id={id}>
            <stop offset='0%' stopColor={iconColor} />
            <stop offset={`${batteryPercentage}%`} stopColor={iconColor} />
            <stop offset={`${batteryPercentage}%`} stopColor='transparent' />
            <stop offset='100%' stopColor='transparent' />
          </linearGradient>
        </defs>
        <path fillRule='evenodd' clipRule='evenodd' d='M12.834 0.709473C13.1101 0.709473 13.334 0.93333 13.334 1.20947L13.334 8.52116C13.334 8.79731 13.1101 9.02116 12.834 9.02116L0.499982 9.02116C0.223839 9.02116 -1.6566e-05 8.7973 -1.65539e-05 8.52116L-1.62343e-05 1.20947C-1.62222e-05 0.93333 0.223841 0.709472 0.499984 0.709472L12.834 0.709473ZM11.9989 1.68693L11.9989 1.88712L11.9989 2.08693L11.9989 7.02026L11.9989 7.22046L11.9989 7.42026L1.13172 7.42026L1.13172 1.68693L11.9989 1.68693ZM3.38525 7.02026L3.38525 2.08693L1.53174 2.08693L1.53174 7.02026L3.38525 7.02026Z' fill={iconColor} />
        <rect x='16' y='1.88721' width='5.33333' height='1.3334' transform='rotate(90 16 1.88721)' fill={iconColor} />
        <path fillRule='evenodd' clipRule='evenodd' d='M12.834 0.709473C13.1101 0.709473 13.334 0.93333 13.334 1.20947L13.334 8.52116C13.334 8.79731 13.1101 9.02116 12.834 9.02116L0.499982 9.02116C0.223839 9.02116 -1.6566e-05 8.7973 -1.65539e-05 8.52116L-1.62343e-05 1.20947C-1.62222e-05 0.93333 0.223841 0.709472 0.499984 0.709472L12.834 0.709473ZM11.9989 1.68693L11.9989 1.88712L11.9989 2.08693L11.9989 7.02026L11.9989 7.22046L11.9989 7.42026L1.13172 7.42026L1.13172 1.68693L11.9989 1.68693ZM11.6089 7.02026L11.6089 2.08693L1.53174 2.08693L1.53174 7.02026L11.6089 7.02026Z' fill={`url(#${id})`} />
        <rect x='16' y='1.88721' width='5.33333' height='1.3334' transform='rotate(90 16 1.88721)' fill={iconColor} />
      </svg>
    )} />
  );
};
